import React from "react";
import { Globe, MapPin, Crosshair, ChevronDown, Layers } from "lucide-react";
import { SearchMode } from "../types/drawerTypes";

interface ScopeSelectorProps {
  searchMode: SearchMode;
  selectedPlanDetail: any;
  selectedPlan: any;
  showScopeMenu: boolean;
  onToggleMenu: () => void;
  onScopeChange: (mode: SearchMode) => void;
}

const ScopeSelector: React.FC<ScopeSelectorProps> = ({
  searchMode,
  selectedPlanDetail,
  selectedPlan,
  showScopeMenu,
  onToggleMenu,
  onScopeChange,
}) => {
  return (
    <div className="relative">
      <button
        onClick={onToggleMenu}
        className="flex items-center gap-1.5 text-slate-600 hover:text-orange-600 font-medium transition py-1 pr-2 rounded-md hover:bg-slate-50"
      >
        <Layers size={14} className="text-orange-500" />
        <span className="whitespace-nowrap">
          Search:{" "}
          <span className="text-slate-800 underline decoration-dotted">
            {searchMode === "global"
              ? "Entire Portfolio"
              : searchMode === "property"
                ? "Current Property (All Lease Plans)"
                : "Current Plan"}
          </span>
        </span>
        <ChevronDown size={12} />
      </button>

      {showScopeMenu && (
        <>
          <div
            className="fixed inset-0 z-30"
            onClick={onToggleMenu}
          ></div>
          <div className="absolute top-full left-0 mt-1 w-56 bg-white rounded-lg shadow-xl border border-slate-100 py-1 z-40 animate-in fade-in zoom-in-95 duration-100">
            <div className="px-3 py-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
              Select Scope
            </div>
            <button
              onClick={() => onScopeChange("current")}
              disabled={!selectedPlanDetail}
              className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-orange-50 hover:text-orange-700 transition disabled:opacity-50 disabled:cursor-not-allowed ${searchMode === "current"
                ? "text-orange-600 font-semibold bg-orange-50/50"
                : "text-slate-600"
                }`}
            >
              <MapPin size={14} />
              Current Plan
            </button>
            <button
              onClick={() => onScopeChange("property")}
              disabled={!selectedPlan}
              className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-orange-50 hover:text-orange-700 transition disabled:opacity-50 disabled:cursor-not-allowed ${searchMode === "property"
                ? "text-orange-600 font-semibold bg-orange-50/50"
                : "text-slate-600"
                }`}
            >
              <Crosshair size={14} />
              Current Property (All Lease Plans)
            </button>
            <button
              onClick={() => onScopeChange("global")}
              className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-orange-50 hover:text-orange-700 transition ${searchMode === "global"
                ? "text-orange-600 font-semibold bg-orange-50/50"
                : "text-slate-600"
                }`}
            >
              <Globe size={14} />
              Entire Portfolio
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ScopeSelector;
